<form [formGroup]="tpmForm">

  <h2>Trailer Summary</h2>

  <div class="p-grid">
    <div class="p-col p-lg-12 p-xl-10">
      <div class="p-grid" *ngIf="invCountTpmInfo.hasTrailerInfo">
        <div class="p-col-12 p-md-6 p-lg-4">
          <p-card>
            <div class="p-grid">
              <div class="p-col-8 p-lg-9 p-xl-9 labelcell">
                <label for="walmartTrailersInYard">WM PL Storage Trailers on Yard and Dock</label>
              </div>
              <div class="p-col-4 p-lg-3 p-xl-3">
                <input type="number" pInputText class="form-control tpmTrailerSummary" id="walmartTrailersInYard"
                        name="walmartTrailersInYard" formControlName="walmartTrailersInYard" lib-numeric>
              </div>
              <div class="p-col-12 fielderror">
                <error-block
                  [field]="tpmForm.controls.walmartTrailersInYard"
                  [messages]="{
                    required: 'Good Wood Trailers on Yard is required.',
                    min: 'Good Wood Trailers on Yard must be greater than or equal to 0.',
                    numeric: 'Good Wood Trailers on Yard must be a number.'
                  }"></error-block>
              </div>
            </div>
            <div class="p-grid">
              <div class="p-col-8 p-lg-9 p-xl-9 labelcell">
                <label for="plRoadworthyTrailers">WM PL Roadworthy Trailers on Yard and Dock</label>
              </div>
              <div class="p-col-4 p-lg-3 p-xl-3">
                <input type="number" pInputText class="form-control tpmTrailerSummary" id="plRoadworthyTrailers"
                        name="plRoadworthyTrailers" formControlName="plRoadworthyTrailers" lib-numeric>
              </div>
              <div class="p-col-12 fielderror">
                <error-block
                  [field]="tpmForm.controls.plRoadworthyTrailers"
                  [messages]="{
                    required: 'Good Wood Trailers on Yard is required.',
                    min: 'Good Wood Trailers on Yard must be greater than or equal to 0.',
                    numeric: 'Good Wood Trailers on Yard must be a number.'
                  }"></error-block>
              </div>
            </div>
            <div class="p-grid">
              <div class="p-col-8 p-lg-9 p-xl-9 labelcell">
                <label for="plsOffSite">Number of PLs Off Site</label>
              </div>
              <div class="p-col-4 p-lg-3 p-xl-3">
                <input class="form-control tpmTrailerSummary" formControlName="plsOffSite" id="plsOffSite" lib-numeric
                        name="plsOffSite" pInputText type="number">
              </div>
              <div class="p-col-12 fielderror">
                <error-block
                  [field]="tpmForm.controls.plsOffSite"
                  [messages]="{
                    required: 'Good Wood Trailers on Yard is required.',
                    min: 'Good Wood Trailers on Yard must be greater than or equal to 0.',
                    numeric: 'Good Wood Trailers on Yard must be a number.'
                  }"></error-block>
              </div>
            </div>
            <div class="p-grid">
              <div class="p-col-8 p-lg-9 p-xl-9 labelcell">
                <label for="breakPackTrailers">Break Pack Consolidated Trailers</label>
              </div>
              <div class="p-col-4 p-lg-3 p-xl-3">
                <input type="number" pInputText class="form-control tpmTrailerSummary" id="breakPackTrailers" name="breakPackTrailers"
                  formControlName="breakPackTrailers" lib-numeric>
              </div>
              <div class="p-col-12 fielderror">
                <error-block
                  [field]="tpmForm.controls.breakPackTrailers"
                  [messages]="{
                    required: 'Good Wood Trailers on Yard is required.',
                    min: 'Good Wood Trailers on Yard must be greater than or equal to 0.',
                    numeric: 'Good Wood Trailers on Yard must be a number.'
                  }"></error-block>
              </div>
            </div>
            <div class="p-grid">
              <div class="p-col-8 p-lg-9 p-xl-9 labelcell">
                <label for="unprocessedBoxTrailers">Unprocessed Box Trailers</label>
              </div>
              <div class="p-col-4 p-lg-3 p-xl-3">
                <input type="number" pInputText class="form-control tpmTrailerSummary" id="unprocessedBoxTrailers"
                  name="unprocessedBoxTrailers" formControlName="unprocessedBoxTrailers" lib-numeric>
              </div>
              <div class="p-col-12 fielderror">
                <error-block
                  [field]="tpmForm.controls.unprocessedBoxTrailers"
                  [messages]="{
                    required: 'Good Wood Trailers on Yard is required.',
                    min: 'Good Wood Trailers on Yard must be greater than or equal to 0.',
                    numeric: 'Good Wood Trailers on Yard must be a number.'
                  }"></error-block>
              </div>
            </div>
            <div class="p-grid">
              <div class="p-col-8 p-lg-9 p-xl-9 labelcell">
                <label for="emptyWalmartTrailers">Total Empty WM Trailers</label>
              </div>
              <div class="p-col-4 p-lg-3 p-xl-3">
                <input type="number" pInputText class="form-control tpmTrailerSummary" id="emptyWalmartTrailers"
                  name="emptyWalmartTrailers" formControlName="emptyWalmartTrailers" lib-numeric>
              </div>
              <div class="p-col-12 fielderror">
                <error-block
                  [field]="tpmForm.controls.emptyWalmartTrailers"
                  [messages]="{
                    required: 'Good Wood Trailers on Yard is required.',
                    min: 'Good Wood Trailers on Yard must be greater than or equal to 0.',
                    numeric: 'Good Wood Trailers on Yard must be a number.'
                  }"></error-block>
              </div>
            </div>
            <div class="p-grid">
              <div class="p-col-8 p-lg-9 p-xl-9 labelcell">
                <label for="uacClaimsTrailers">UAC Claims Trailers</label>
              </div>
              <div class="p-col-4 p-lg-3 p-xl-3">
                <input class="form-control tpmTrailerSummary" formControlName="uacClaimsTrailers" id="uacClaimsTrailers"
                        lib-numeric name="uacClaimsTrailers" pInputText type="number">
              </div>
              <div class="p-col-12 fielderror">
                <error-block
                  [field]="tpmForm.controls.uacClaimsTrailers"
                  [messages]="{
                    required: 'Good Wood Trailers on Yard is required.',
                    min: 'Good Wood Trailers on Yard must be greater than or equal to 0.',
                    numeric: 'Good Wood Trailers on Yard must be a number.'
                  }"></error-block>
              </div>
            </div>
          </p-card>
        </div>

        <div class="p-col-12 p-md-6 p-lg-4">
          <p-card>
            <div class="p-grid">
              <div class="p-col-8 p-lg-9 p-xl-9 labelcell">
                <label for="goodWoodWalmartTrailers">Good Wood Trailers on Yard</label>
              </div>
              <div class="p-col-4 p-lg-3 p-xl-3">
                <input type="number" pInputText class="form-control tpmTrailerSummary" id="goodWoodWalmartTrailers"
                  name="goodWoodWalmartTrailers" formControlName="goodWoodWalmartTrailers" lib-numeric>
              </div>
              <div class="p-col-12 fielderror">
                <error-block
                  [field]="tpmForm.controls.goodWoodWalmartTrailers"
                  [messages]="{
                    required: 'Good Wood Trailers on Yard is required.',
                    min: 'Good Wood Trailers on Yard must be greater than or equal to 0.',
                    numeric: 'Good Wood Trailers on Yard must be a number.'
                  }"></error-block>
              </div>
            </div>
            <div class="p-grid">
              <div class="p-col-8 p-lg-9 p-xl-9 labelcell">
                <label for="goodWoodInDcDoors">Good Wood Trailers in Door</label>
              </div>
              <div class="p-col-4 p-lg-3 p-xl-3">
                <input type="number" pInputText class="form-control tpmTrailerSummary" id="goodWoodInDcDoors"
                  name="goodWoodInDcDoors" formControlName="goodWoodInDcDoors" lib-numeric>
              </div>
              <div class="p-col-12 fielderror">
                <error-block
                  [field]="tpmForm.controls.goodWoodInDcDoors"
                  [messages]="{
                    required: 'Good Wood Trailers in Door is required.',
                    min: 'Good Wood Trailers in Door must be greater than or equal to 0.',
                    numeric: 'Good Wood Trailers in Door must be a number.'
                  }"></error-block>
              </div>
            </div>
            <div class="p-grid">
              <div class="p-col-8 p-lg-9 p-xl-9 labelcell">
                <label for="automationTrailersOnYard">Automation Good Wood Trailer on Yard</label>
              </div>
              <div class="p-col-4 p-lg-3 p-xl-3">
                <input type="number" pInputText class="form-control tpmTrailerSummary" id="automationTrailersOnYard"
                  name="automationTrailersOnYard" formControlName="automationTrailersOnYard" lib-numeric>
              </div>
              <div class="p-col-12 fielderror">
                <error-block
                  [field]="tpmForm.controls.automationTrailersOnYard"
                  [messages]="{
                    required: 'Automation Good Wood Trailer on Yard is required.',
                    min: 'Automation Good Wood Trailer on Yard must be greater than or equal to 0.',
                    numeric: 'Automation Good Wood Trailer on Yard must be a number.'
                  }"></error-block>
              </div>
            </div>
            <div class="p-grid">
              <div class="p-col-8 p-lg-9 p-xl-9 labelcell">
                <label for="automationTrailersInDoors">Good Wood Trailer in Door Automation</label>
              </div>
              <div class="p-col-4 p-lg-3 p-xl-3">
                <input type="number" pInputText class="form-control tpmTrailerSummary" id="automationTrailersInDoors"
                  name="automationTrailersInDoors" formControlName="automationTrailersInDoors" lib-numeric>
              </div>
              <div class="p-col-12 fielderror">
                <error-block
                  [field]="tpmForm.controls.automationTrailersInDoors"
                  [messages]="{
                    required: 'Good Wood Trailer in Door Automation is required.',
                    min: 'Good Wood Trailer in Door Automation must be greater than or equal to 0.',
                    numeric: 'Good Wood Trailer in Door Automation must be a number.'
                  }"></error-block>
              </div>
            </div>
            <div class="p-grid">
              <div class="p-col-8 p-lg-9 p-xl-9 labelcell">
                <label for="gwOffSite">Number of GW Off Site</label>
              </div>
              <div class="p-col-4 p-lg-3 p-xl-3">
                <input class="form-control tpmTrailerSummary" formControlName="gwOffSite" id="gwOffSite" lib-numeric
                        name="gwOffSite" pInputText type="number">
              </div>
              <div class="p-col-12 fielderror">
                <error-block
                  [field]="tpmForm.controls.gwOffSite"
                  [messages]="{
                    required: 'Number of GW Off Site is required.',
                    min: 'Number of GW Off Site must be greater than or equal to 0.',
                    numeric: 'Number of GW Off Site must be a number.'
                  }"></error-block>
              </div>
            </div>
            <div class="p-grid" *ngIf="!!(rackCapacity | async)">
              <div class="p-col-8 p-lg-9 p-xl-9 labelcell">
                <label for="goodWoodInRacks">Number of GW on Racks</label>
              </div>
              <div class="p-col-4 p-lg-3 p-xl-3">
                <input type="number" pInputText class="form-control tpmTrailerSummary" id="goodWoodInRacks"
                  name="goodWoodInRacks" formControlName="goodWoodInRacks" lib-numeric>
              </div>
              <div class="p-col-12 fielderror">
                <error-block
                  [field]="tpmForm.controls.goodWoodInRacks"
                  [messages]="{
                    required: 'Number of GW on Racks is required.',
                    min: 'Number of GW on Racks must be greater than or equal to 0.',
                    numeric: 'Number of GW on Racks must be a number.'
                  }"></error-block>
                <p-message *ngIf="(rackWarning | async) as warning" severity="warn" [text]="warning"></p-message>
              </div>
            </div>
          </p-card>
        </div>

        <div class="p-col-12 p-md-6 p-lg-4">
          <p-card>
            <div class="p-grid">
              <div class="p-col-8 p-lg-9 p-xl-9 labelcell">
                <label for="startOfDayRpcLoads">Unprocessed RPC Trailers</label>
              </div>
              <div class="p-col-4 p-lg-3 p-xl-3">
                <input type="number" pInputText class="form-control tpmTrailerSummary" id="startOfDayRpcLoads" name="startOfDayRpcLoads"
                  formControlName="startOfDayRpcLoads" lib-numeric>
              </div>
              <div class="p-col-12 fielderror">
                <error-block
                  [field]="tpmForm.controls.startOfDayRpcLoads"
                  [messages]="{
                    required: 'Unprocessed RPC Trailers is required.',
                    min: 'Unprocessed RPC Trailers must be greater than or equal to 0.',
                    numeric: 'Unprocessed RPC Trailers must be a number.'
                  }"></error-block>
              </div>
            </div>
            <div class="p-grid">
              <div class="p-col-8 p-lg-9 p-xl-9 labelcell">
                <label for="startOfDayUnsortedRpcPallets">Floor Inventory of Unsorted RPCs Pallets</label>
              </div>
              <div class="p-col-4 p-lg-3 p-xl-3">
                <input type="number" pInputText class="form-control tpmTrailerSummary" id="startOfDayUnsortedRpcPallets" name="startOfDayUnsortedRpcPallets"
                  formControlName="startOfDayUnsortedRpcPallets" lib-numeric>
              </div>
              <div class="p-col-12 fielderror">
                <error-block
                  [field]="tpmForm.controls.startOfDayUnsortedRpcPallets"
                  [messages]="{
                    required: 'Unsorted RPCs Pallets is required.',
                    min: 'Unsorted RPCs Pallets must be greater than or equal to 0.',
                    numeric: 'Unsorted RPCs Pallets must be a number.'
                  }"></error-block>
              </div>
            </div>
            <div class="p-grid">
              <div class="p-col-8 p-lg-9 p-xl-9 labelcell">
                <label for="rpcTrailersReadyToShip">RPC Consolidated Trailers / TO</label>
              </div>
              <div class="p-col-4 p-lg-3 p-xl-3">
                <input type="number" pInputText class="form-control tpmTrailerSummary" id="rpcTrailersReadyToShip"
                  name="rpcTrailersReadyToShip" formControlName="rpcTrailersReadyToShip" lib-numeric>
              </div>
              <div class="p-col-12 fielderror">
                <error-block
                  [field]="tpmForm.controls.rpcTrailersReadyToShip"
                  [messages]="{
                    required: 'RPC Consolidated Trailers is required.',
                    min: 'RPC Consolidated Trailers must be greater than or equal to 0.',
                    numeric: 'RPC Consolidated Trailers must be a number.'
                  }"></error-block>
              </div>
            </div>
            <div class="p-grid">
              <div class="p-col-8 p-lg-9 p-xl-9 labelcell">
                <label for="toscaMeatTrailers">RPC - Total Tosca Empty Meat Trailers</label>
              </div>
              <div class="p-col-4 p-lg-3 p-xl-3">
                <input type="number" pInputText class="form-control tpmTrailerSummary" id="toscaMeatTrailers"
                  name="toscaMeatTrailers" formControlName="toscaMeatTrailers" lib-numeric>
              </div>
              <div class="p-col-12 fielderror">
                <error-block
                  [field]="tpmForm.controls.toscaMeatTrailers"
                  [messages]="{
                    required: 'Tosca Empty Meat Trailers is required.',
                    min: 'Tosca Empty Meat Trailers must be greater than or equal to 0.',
                    numeric: 'Tosca Empty Meat Trailers must be a number.'
                  }"></error-block>
              </div>
            </div>
            <div class="p-grid">
              <div class="p-col-8 p-lg-9 p-xl-9 labelcell">
                <label for="toscaEggTrailers">RPC - Total Tosca Empty Egg Trailers</label>
              </div>
              <div class="p-col-4 p-lg-3 p-xl-3">
                <input type="number" pInputText class="form-control tpmTrailerSummary" id="toscaEggTrailers"
                        name="toscaEggTrailers" formControlName="toscaEggTrailers" lib-numeric>
              </div>
              <div class="p-col-12 fielderror">
                <error-block
                  [field]="tpmForm.controls.toscaEggTrailers"
                  [messages]="{
                    required: 'Total Tosca Empty Egg Trailers is required.',
                    min: 'Total Tosca Empty Egg Trailers must be greater than or equal to 0.',
                    numeric: 'Total Tosca Empty Egg Trailers must be a number.'
                  }"></error-block>
              </div>
            </div>
            <div class="p-grid">
              <div class="p-col-8 p-lg-9 p-xl-9 labelcell">
                <label for="rpcIfcoTrailersEmpty">RPC - Total Empty IFCO Produce Trailers</label>
              </div>
              <div class="p-col-4 p-lg-3 p-xl-3">
                <input type="number" pInputText class="form-control tpmTrailerSummary" id="rpcIfcoTrailersEmpty"
                        name="rpcIfcoTrailersEmpty" formControlName="rpcIfcoTrailersEmpty" lib-numeric>
              </div>
              <div class="p-col-12 fielderror">
                <error-block
                  [field]="tpmForm.controls.rpcIfcoTrailersEmpty"
                  [messages]="{
                    required: 'Empty IFCO Produce Trailers is required.',
                    min: 'Empty IFCO Produce Trailers must be greater than or equal to 0.',
                    numeric: 'Empty IFCO Produce Trailers must be a number.'
                  }"></error-block>
              </div>
            </div>
            <div class="p-grid">
              <div class="p-col-8 p-lg-9 p-xl-9 labelcell">
                <label for="rpcToscaTrailersEmpty">RPC - Total Empty Tosca/Polymer Produce Trailers</label>
              </div>
              <div class="p-col-4 p-lg-3 p-xl-3">
                <input type="number" pInputText class="form-control tpmTrailerSummary" id="rpcToscaTrailersEmpty"
                        name="rpcToscaTrailersEmpty" formControlName="rpcToscaTrailersEmpty" lib-numeric>
              </div>
              <div class="p-col-12 fielderror">
                <error-block
                  [field]="tpmForm.controls.rpcToscaTrailersEmpty"
                  [messages]="{
                    required: 'Empty Tosca/Polymer Produce Trailers is required.',
                    min: 'Empty Tosca/Polymer Produce Trailers must be greater than or equal to 0.',
                    numeric: 'Empty Tosca/Polymer Produce Trailers must be a number.'
                  }"></error-block>
              </div>
            </div>
          </p-card>
        </div>
      </div>
    </div>
  </div>

  <div class="p-grid">
    <div class="p-col p-lg-10 p-xl-8">
      <p-card header="Comments">
        <textarea pInputTextarea class="form-control textarea" formControlName="comments"></textarea>
      </p-card>

      <p-card header="Store Returns">
        <div class="p-col horAlignment" [ngClass]="'showShifts' + showShift">
          <div class="p-grid">
            <div class="form-group p-col-2 shift1">
              <label for="storeReturnsWorkedS1">{{ showShift === 0 ? 'Shift 1' : 'Total'}}</label>
              <input type="number" pInputText class="form-control chepInput" id="storeReturnsWorkedS1"
                formControlName="storeReturnsWorkedS1" lib-numeric>
              <error-block
                [field]="tpmForm.controls.storeReturnsWorkedS1"
                [messages]="{
                  max: 'Returns must be less than 75.'
                }"></error-block>
            </div>
            <div class="form-group p-col-2 shift2">
              <label for="storeReturnsWorkedS2">{{ showShift === 0 ? 'Shift 2' : 'Total'}}</label>
              <input type="number" pInputText class="form-control chepInput" id="storeReturnsWorkedS2"
                name="storeReturnsWorkedS2" formControlName="storeReturnsWorkedS2" lib-numeric max="75">
              <error-block
                [field]="tpmForm.controls.storeReturnsWorkedS1"
                [messages]="{
                  max: 'Returns must be less than 75.'
                }"></error-block>
            </div>
            <div class="form-group p-col-2 shift3">
              <label for="storeReturnsWorkedS3">{{ showShift === 0 ? 'Shift 3' : 'Total'}}</label>
              <input type="number" pInputText class="form-control chepInput" id="storeReturnsWorkedS3"
                name="storeReturnsWorkedS3" formControlName="storeReturnsWorkedS3" lib-numeric max="75">
              <error-block
                [field]="tpmForm.controls.storeReturnsWorkedS1"
                [messages]="{
                  max: 'Returns must be less than 75.'
                }"></error-block>
            </div>
            <div class="form-group p-col-2 shift4">
              <label for="storeReturnsWorkedS4">{{ showShift === 0 ? 'Shift 4' : 'Total'}}</label>
              <input type="number" pInputText class="form-control chepInput" id="storeReturnsWorkedS4"
                name="storeReturnsWorkedS4" formControlName="storeReturnsWorkedS4" lib-numeric max=75>
              <error-block
                [field]="tpmForm.controls.storeReturnsWorkedS1"
                [messages]="{
                  max: 'Returns must be less than 75.'
                }"></error-block>
            </div>
            <div class="form-group p-col-2 shift5">
              <label for="storeReturnsWorkedS5">{{ showShift === 0 ? 'Shift 5' : 'Total'}}</label>
              <input type="number" pInputText class="form-control chepInput" id="storeReturnsWorkedS5"
                name="storeReturnsWorkedS5" formControlName="storeReturnsWorkedS5" lib-numeric max="75">
              <error-block
                [field]="tpmForm.controls.storeReturnsWorkedS1"
                [messages]="{
                  max: 'Returns must be less than 75.'
                }"></error-block>
            </div>
            <div class="form-group p-col-2 total">
              <label for="storeReturnsTotal">Total</label>
              <input type="number" pInputText class="form-control chepInput" id="storeReturnsTotal"
                name="storeReturnsTotal" readonly [value]="returnsTotal">
            </div>
          </div>
        </div>
      </p-card>
    </div>
  </div>
</form>
